import { useId, type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const FacebookSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => {
  const pathId = useId();

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <defs>
          <clipPath id={pathId}>
            <path fill="none" d="M9.45 5.29h9.1v17.43h-9.1z" />
          </clipPath>
        </defs>
        <g clip-path={`url(#${pathId})`}>
          <path
            fill="currentColor"
            d="m18.38 5.35-2.55-.06c-1.01-.02-1.97.36-2.7 1.07C12.4 7.07 12 8.02 12 9.03v2.42H9.63c-.1 0-.18.08-.18.18v3.04c0 .1.08.18.18.18H12v7.7c0 .1.08.18.18.18h3.14c.1 0 .18-.08.18-.18v-7.7h2.39c.09 0 .16-.07.17-.15l.4-3.04c0-.05 0-.1-.04-.14a.161.161 0 0 0-.13-.06H15.5V9.92s-.06-.75.32-1.17c.18-.2.43-.29.75-.29h1.8c.1 0 .18-.08.18-.18V5.53c0-.09-.08-.17-.17-.18"
          />
        </g>
      </svg>
    </Icon>
  );
};

export default FacebookSVG;
